const topBrand = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let secBrand = document.querySelector('#jsSecBrand');
    let mainWrap = secBrand.querySelector('.js-main-wrap');
    let mainArea1 = mainWrap.querySelector('.js-main-area-1');
    // let bg = bgWrap.querySelector('.js-bg');


    {
      let to1 = gsap.to(mainArea1, {
        ease: "none",
        scrollTrigger: {
          trigger: mainArea1,
          start: '100% 100%',
          endTrigger: mainWrap,
          end: '100% 0%',
          pin: true,
          pinSpacing: false,
          // markers: true
        }
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          to1.scrollTrigger.refresh()
          // console.log('comParallax refresh');
        });
      });
      observer.observe(target);
    }


  }
})()
export default topBrand;